module.exports = __webpack_public_path__ + "assets/img/speech.e4d7b0b7.svg";